import React, {Component} from 'react';
import {InlineCarouselContainer, CarouselUtil, CarouselButtons} from '@homeaway/react-image-carousel';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import PropTypes from 'prop-types';
import {TrackFocus} from '@homeaway/a11y-tools';
import CarouselButtonsDesktop from './carouselTemplates/CarouselButtonsDesktop/CarouselButtonsDesktop';
import CarouselButtonsMobile from './carouselTemplates/CarouselButtonsMobile/CarouselButtonsMobile';
import carouselPageNumberDesktop from './carouselTemplates/CarouselPageNumberDesktop/CarouselPageNumberDesktop';
import './image-carousel.less';

export const ImageCarouselSlidePlaceholder = () => {
    return <LoadingOverlay loading />;
};

const trackFocus = new TrackFocus();
trackFocus.bindEvents();

export class ImageCarousel extends Component {
    static propTypes = {
        images: PropTypes.arrayOf(PropTypes.shape),
        showPageNumber: PropTypes.bool,
        onCarouselArrowClick: PropTypes.func,
        onCarouselHitClick: PropTypes.func,
        renderButtonCircle: PropTypes.bool,
        isMobile: PropTypes.bool
    };

    static defaultProps = {
        images: [],
        showPageNumber: false,
        renderButtonCircle: false,
        isMobile: false,
        onCarouselArrowClick: () => {},
        onCarouselHitClick: () => {}
    };

    constructor(props) {
        super(props);
        this.state = {index: 0};
    }

    handleNextImage = (currentIndex, imagesLength) => {
        this.setState({
            index: CarouselUtil.getNextIndex(currentIndex, imagesLength)
        });

        this.props.onCarouselArrowClick('next', this.state.index);
    };

    handlePreviousImage = (currentIndex, imagesLength) => {
        this.setState({
            index: CarouselUtil.getPrevIndex(currentIndex, imagesLength)
        });

        this.props.onCarouselArrowClick('back', this.state.index);
    };

    getRenderedIndices = () => {
        return CarouselUtil.getRenderIndices(this.props.images.length, this.state.index, 1);
    };

    onImageClick = () => {
        if (this.props.onCarouselHitClick) {
            this.props.onCarouselHitClick(this.state.index, this.props.images.length);
        }
    };

    renderButtonSet = () => {
        return this.props.isMobile // eslint-disable-line no-nested-ternary
            ? CarouselButtonsMobile
            : !this.props.isMobile && this.props.renderButtonCircle ? CarouselButtonsDesktop : CarouselButtons;
    };

    // stops event from bubbling through to the anchor tag by default
    preventEventBubble = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    render() {
        const {images, renderButtonCircle, showPageNumber, slideSize} = this.props;
        // SCRATCHPAD-2439 switching to low res images for DT and Mobile
        const lowResImages = images
            .filter((image) => !!image)
            .map(({src: lowResSrc, lowResSrc: src, ...rest}) => ({src, lowResSrc, ...rest}));
        return (
            <div
                className="image-carousel"
                onClick={this.preventEventBubble}
                onKeyPress={this.preventEventBubble}
                role="button"
                tabIndex="0"
            >
                <InlineCarouselContainer
                    hideBackground
                    renderInteractive
                    showArrows
                    images={lowResImages || []}
                    index={this.state.index}
                    onImageClick={this.onImageClick}
                    onNextImage={this.handleNextImage}
                    onPrevImage={this.handlePreviousImage}
                    reduceButtonHitTarget
                    renderedIndices={this.getRenderedIndices()}
                    renderPlaceholder={ImageCarouselSlidePlaceholder}
                    overlayColor="#fff"
                    maxOverlayOpacity={renderButtonCircle ? 0.8 : 0}
                    slideSize={slideSize}
                    showPageNumber={showPageNumber}
                    renderButtons={this.renderButtonSet()}
                    renderPageNumber={carouselPageNumberDesktop(this.onCarouselImageClicked)}
                />
            </div>
        );
    }
}

export default ImageCarousel;



// WEBPACK FOOTER //
// ./src/universal/components/image-carousel/image-carousel.js